import { ChangeDetectorRef, Component, Inject, OnInit, output, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuctionService } from '../../../../services/AuctionService';
import { AuthenticationService } from '../../../../services/AuthenticationService';
import { Property } from '../../../../models/property';
import { take } from 'rxjs';
import { AppConfig } from '../../../../app.config';
import { Stripe } from '@stripe/stripe-js';
import { StripeService } from '../../../../services/StripeService';

declare var Stripe: any;

@Component({ standalone: false,
  selector: 'app-authorization-stripe',
  templateUrl: 'authorization-stripe.component.html',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class AuthorizationStripeComponent implements OnInit {
  readonly onAuthorizationExecuted = output<any>();
  public title: string= "Credit Card Authorization";
  public confirmButtonText = "Authorize";
  public cancelButtonText = "Cancel";

  public busy:boolean=false;
  public paymentIntentId!:string;
  public paymentIntent?:string;
  public stripeMessage?: string;

  public property!:Property;
  public redirectUrl!:string;

  public paymentIntentRegistered:boolean=false;

  private stripe: Stripe | null = null;


  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private auctionService:AuctionService, private authService:AuthenticationService, private appConfig:AppConfig, 
    private cdRef:ChangeDetectorRef, private stripeService:StripeService) {
    if(data){
      this.property=data.property;
      this.redirectUrl=this.appConfig.getConfig("website_url")+data.redirectUrl;
      this.paymentIntentId=data.paymentIntentId?data.paymentIntentId:undefined;
    }
  }

  async ngOnInit() {
    // Only load Stripe on this page
    this.stripe = await this.stripeService.getStripe();
  }

  ngAfterViewInit() {
    if(!this.paymentIntentId){
      this.busy=true;
      this.cdRef.detectChanges();
      this.auctionService.createPaymentIntentStripe(this.property.auction!.id, this.property.auction!.scheduleSeqNo!,this.amountToAuthorize, this.property.header!).pipe(take(1)).subscribe(r=>{
        if(r.success) this.initStripe(r.clientSecret!);
        else{
          this.busy=false;
          this.stripeMessage="Something went wrong. Please try again later."
        }
      });
    }
    else{
      //submit paymentIntent to server
      this.registerSuccessfulPaymentIntent();
    }
  }

  private initStripe(clientSecret:string){
    const stripe = Stripe(this.appConfig.getConfig("stripe_public_key"));

    const appearance = {
      theme: 'stripe',
    };

    const elements = stripe.elements({ appearance, clientSecret });

    const paymentElementOptions = { layout: "tabs", };

    const paymentElement = elements.create("payment", paymentElementOptions);
    paymentElement.mount("#payment-element");

    paymentElement.addEventListener('change', (event:any) => {
      const displayError = document.getElementById('card-errors')!;
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });

    // Listen for form submission, process the form with Stripe,
    const paymentForm = document.getElementById('payment-form');
    paymentForm?.addEventListener('submit', event => {
      event.preventDefault();
      this.stripeMessage='';
      this.busy=true;
      stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: this.redirectUrl, // in need to foresee a return url logic by mentioning here the current auction page and then in auction page check for url params and if stripe params present, then open a popup showing that payment successful.
          receipt_email: this.authService.currentUserValue!.email,
        },
        redirect: 'if_required', //this will allow to avoid redirect if not required=>we need to handle succesful result our selves
      }).then((result:any) => {
        this.busy=false;
        if(result.paymentIntent){
          //success => submit paymentIntent to server for registration. show user that charge was successful (hide cc form) and allow user to click OK to close dialog
          this.paymentIntent=JSON.stringify(result.paymentIntent);
          this.paymentIntentId=result.paymentIntent.id;
          this.registerSuccessfulPaymentIntent();
        }
        if (result.error) {
          // Inform the customer that there was an error.
          if (result.error?.type === "card_declined" || result.error?.type === "expired_card" || result.error?.type === "card_error" || result.error?.type === "validation_error") {
            this.stripeMessage=result.error.message;
          } else {
            this.stripeMessage=result.error.message;
          }
        }
      });
    });
    this.busy=false;
  }

  get amountToAuthorize(){
    return this.property.auction?.amountToAuthorize ?? 0;
  }

  private registerSuccessfulPaymentIntent(){
    this.auctionService.authorizeForAuctionStripe(this.property.auction!.id, this.property.auction!.scheduleSeqNo!, this.amountToAuthorize, this.paymentIntentId, this.paymentIntent!, true, true).pipe(take(1)).subscribe(r=>{
      if(r.success){
        this.paymentIntentRegistered=true;
        //update parent dialog to show current authorization status by raising an event
        this.onAuthorizationExecuted.emit(r);
      }
      else{
        //TODO some error handling or retry
      }
    });
  }
}



